/* eslint-disable max-len */
import 'react';

const SidebarArrowLeftSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="8px" height="10px" viewBox="0 0 8 10" version="1.1" fill="currentColor" {...props}>
        <g id="控件" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="切图" transform="translate(-159.000000, -57.000000)" fill="currentColor" fillRule="nonzero">
                <path d="M166.896194,58.6461941 C167.310408,58.6461941 167.646194,58.9819805 167.646194,59.3961941 C167.646194,59.7758898 167.36404,60.089685 166.997965,60.1393475 L166.896194,60.1461941 L162.64566,60.1456602 L162.646194,64.3961941 C162.646194,64.7758898 162.36404,65.089685 161.997965,65.1393475 L161.896194,65.1461941 C161.516498,65.1461941 161.202703,64.8640402 161.153041,64.4979646 L161.146194,64.3961941 L161.146194,59.3961941 C161.146194,59.0164983 161.428348,58.7027031 161.794424,58.6530407 L161.896194,58.6461941 L166.896194,58.6461941 Z" id="路径" transform="translate(164.396194, 61.896194) rotate(-45.000000) translate(-164.396194, -61.896194) "></path>
            </g>
        </g>
    </svg>
);
export default SidebarArrowLeftSvg;
